import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuth } from "../redux/slice/authSlice";
import useEncryption from "../services/useEncryption";

const PublicRoute = ({ component: Component }) => {
    const { userProfile, id, role } = useSelector(selectAuth);
    const { encryptData, decryptData } = useEncryption();
    const token = sessionStorage.getItem("token");

  if (token) {
    const encryptedId = encryptData(id);
    const user_id = encodeURIComponent(encryptedId);
    // Redirect based on user role
    if (role === "admin") return <Navigate to="/admin/dashboard" />;
    if (role === "doctor") return <Navigate to={`/doctor/${user_id}`} />;
    if (role === "provider") return <Navigate to={`/provider/${user_id}`} />;
    if (role === "staff") return <Navigate to={`/staff/${user_id}`} />; 
  }

  return <Component />;
};

export default PublicRoute;
